import { ListService } from "@abp/ng.core";
import { ConfirmationService } from "@abp/ng.theme.shared";
import { Component, inject } from "@angular/core";
import { GenericForm, BaseHierarchicalCrudComponent, ZnHierarchicalViewComponent } from "@zendra/shared";
import { OtherUsePerRegisterService } from "cbd-proxies";
import { OtherUsePerRegisterDto, OtherUsePerRegisterCreateDto, OtherUsePerRegisterUpdateDto, OtherUsePerRegisterExcelDownloadDto } from "projects/cbd-proxies/src/lib/planning/dtos/other-use-per-register";
import { OTHERUSEPERREGISTER_CONFIG, OTHERUSEPERREGISTER_FIELDS } from "./other-use-per-register.config";

@Component({
  selector: 'app-other-use-per-register',
  imports: [
    ZnHierarchicalViewComponent,
    GenericForm,
  ],
  providers: [ListService, OtherUsePerRegisterService, ConfirmationService],
  templateUrl: './other-use-per-register.html',
})
export class OtherUsePerRegister extends BaseHierarchicalCrudComponent<
  OtherUsePerRegisterDto,
  OtherUsePerRegisterCreateDto,
  OtherUsePerRegisterUpdateDto,
  OtherUsePerRegisterExcelDownloadDto
> {
  service = inject(OtherUsePerRegisterService);
  config = OTHERUSEPERREGISTER_CONFIG;
  fields = OTHERUSEPERREGISTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: OtherUsePerRegisterDto): OtherUsePerRegisterUpdateDto {
    return {
      otherUseId: data.otherUseId,
      registerId: data.registerId,
      gisOtherUseRegisterArea: data.gisOtherUseRegisterArea,
      registerAreaCorrection: data.registerAreaCorrection,
      otherUseRegisterArea: data.otherUseRegisterArea,
      otherUseAreaPercentage: data.otherUseAreaPercentage,
      isMainRegister: data.isMainRegister,
      isLastRegister: data.isLastRegister,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'OtherUsePerRegister';
  }
}
